import React from "react";
import { AUTH_FOOTER_LINKS } from "../../utility/constants/authUi";
import { LockIcon } from "./icons";
import LoginSidePanel from "./LoginSidePanel";

const Container = ({ children }) => {
  return (
    <div className="login-layout">
      <main className="login-card">
        <section className="login-form-pane">{children}</section>
        <LoginSidePanel />
      </main>
      <footer className="login-site-foot">
        <div className="login-secure">
          <LockIcon />
          <span>Secured with 256-bit TLS encryption</span>
          <span className="login-sep" aria-hidden="true">
            ·
          </span>
          <span>SOC 2 Type II</span>
          <span className="login-sep" aria-hidden="true">
            ·
          </span>
          <span>ISO 27001</span>
        </div>
        <nav className="login-foot-links" aria-label="Legal and support">
          <a href={AUTH_FOOTER_LINKS.privacy} target="_blank" rel="noreferrer">
            Privacy
          </a>
          <a href={AUTH_FOOTER_LINKS.terms} target="_blank" rel="noreferrer">
            Terms
          </a>
          <a href={AUTH_FOOTER_LINKS.security} target="_blank" rel="noreferrer">
            Security
          </a>
        </nav>
      </footer>
    </div>
  );
};

export default Container;
